<template>
  <div class="space-y-0.5 px-4">
    <h4 class="text-text-neutral-primary text-lg font-semibold">
      {{ directionText }}
    </h4>
    <p class="text-text-neutral-quaternary text-sm">
      {{ dateText }}
      <slot></slot>
    </p>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import { useI18n } from 'vue-i18n';
  import { dateUtils } from 'shared';

  import { GraphDirectionEnum } from '../types';
  import type { GraphDirection, MappedRoundTripNearestSearch } from '../types';

  const props = defineProps<{
    activeSearch: MappedRoundTripNearestSearch;
    direction: GraphDirection;
    city: string | null;
  }>();

  const { t } = useI18n();

  const directionText =
    props.direction === GraphDirectionEnum.TO
      ? t('search.nearestSearchesRoundTrip.directionTo', { city: props.city })
      : t('search.nearestSearchesRoundTrip.directionBack', {
          city: props.city,
        });

  const dateText = computed(() => {
    const date = props.activeSearch.departureDate;
    const weekDay = dateUtils.getPrettyDayOfWeek(date);

    return `${dateUtils.getVerbalDate(
      date,
    )}, ${weekDay[0].toUpperCase()}${weekDay.slice(1)}`;
  });
</script>
